<template>
  <section>
    <!-- 统计文字 -->
   
    <el-row style="padding:15px;background:#fff">
    	
      <el-col :sm="24" :xs="24" >
        <el-row :gutter="10">
          <el-button size="small" type="primary" @click="goback" icon="el-icon-back">返回</el-button>
          <el-select  v-model="pdata.company_id"  clearable filterable placeholder="请选择对应公司">
              <el-option v-for="item in companys" :key="item.company_id" :label="item.company_name" :value="item.company_id"></el-option>
          </el-select>
            <el-select  v-model="pdata.issued_app_id"  clearable filterable placeholder="请选择产品">
              <el-option v-for="item in apps" :key="item.issued_app_id" :label="item.name" :value="item.issued_app_id"></el-option>
          </el-select>
          <!--<el-date-picker size="small" v-model="pdata.date" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>-->
         
        </el-row>
      </el-col>
      <!--<el-col :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <searchApp  class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
          </el-row>
        </div>
      </el-col>-->
    </el-row>
    <el-row style="padding:15px;background:#fff">
    	<el-col :sm="24" :xs="24" >
        <el-row :gutter="10">
        	<el-button class="xs24" type="primary" plain @click="changeDate(1)">昨天</el-button>
        	<el-button class="xs24" type="primary" plain @click="changeDate(2)">前天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(7)">最近7天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(31)">最近31天</el-button>
          <el-date-picker class="xs24" v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="今天" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
        
        </el-row>
      </el-col>
    
	    <el-table :data="list" style="width: 100%;" stripe    @expand-change="expands" class="selfTable"  v-loading="loading" :default-sort = "{prop: 'visit_uv_out', order: 'descending'}"  show-summary
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
	    	 <el-table-column type="expand" prop="name" v-if="dateVal[0]!==dateVal[1]" style="padding: 0;" class="expandd">
		        <template slot-scope="s">
		           <el-table :data="s.row.exData" :show-header="false" >
		           	  <el-table-column prop="d_date" label="" align="center"  width="48px">
		           	  	 <template slot-scope="scope" >
					                <span>&nbsp;</span>
					            </template>
		           	  </el-table-column>
		              <el-table-column prop="d_date" label="日期" align="center" ></el-table-column>
		              <el-table-column prop="visit_uv_out" show-overflow-tooltip label="换出日活" align="center" ></el-table-column>
									<el-table-column prop="visit_uv_in" show-overflow-tooltip label="换入日活" align="center"></el-table-column>
									<el-table-column prop="diff" show-overflow-tooltip label="顺逆差" align="center" ></el-table-column>
									<!--<el-table-column prop="" label="操作" fixed="right" align="center"  width="180">
					            <template slot-scope="scope" >
					                <el-button size="mini" type="primary" @click.native="editProduct(scope.row,'day',s.$index)" v-if="groupid==4||groupid==0">编辑</el-button>
					            </template>
					        </el-table-column>-->
		           </el-table>
		        </template>
		      </el-table-column>
	        <el-table-column prop="name" show-overflow-tooltip label="流量主游戏" align="center" ></el-table-column>
	        <el-table-column prop="visit_uv_out" show-overflow-tooltip label="换出日活" align="center" sortable :sort-method="(a,b)=>{return (a.visit_uv_out-0)-(b.visit_uv_out-0)}"></el-table-column>
	        <el-table-column prop="visit_uv_in" show-overflow-tooltip label="换入日活" align="center"  sortable :sort-method="(a,b)=>{return (a.visit_uv_in-0)-(b.visit_uv_in-0)}"></el-table-column>
	        <el-table-column prop="diff" show-overflow-tooltip label="顺逆差" align="center" sortable :sort-method="(a,b)=>{return (a.diff-0)-(b.diff-0)}"></el-table-column>
	      
	        <!--<el-table-column prop="" label="操作" fixed="right" align="center"  width="180">
	            <template slot-scope="scope" >
	                <el-button size="mini" type="primary" @click.native="editProduct(scope.row,'list')" v-if="(dateVal[0]==dateVal[1])&&(groupid==4||groupid==0)">编辑</el-button>
	                <span v-else>&nbsp;</span>
	            </template>
	        </el-table-column>-->
	    </el-table>
		</el-row>
    <!--<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>-->
		<el-dialog title="编辑实际换量" :visible.sync="editDialog" width="550px" :close-on-click-modal="false">
     	 <el-form :model="chooseEditProduct">
     	 	 <el-row :gutter="10">
		         <el-col :sm="12" :xs="12" >
		             <el-form-item label="换出日活">
		                 <el-input-number size="small" v-model="chooseEditProduct.visit_uv_out" :step="1" :precision="0" :min="0" label="" :controls="false"></el-input-number>
		             </el-form-item>
		         </el-col>
		     	 	 	<el-col :sm="12" :xs="12" >
                <el-form-item label="换入日活">
                    <el-input-number size="small" v-model="chooseEditProduct.visit_uv_in" :step="1" :precision="0"    :min="0" label="" :controls="false"></el-input-number>
                </el-form-item>
		     	 	 	</el-col>
     	 	 </el-row>	
     	
	
     	 
     	 </el-form>
     	 <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click.native="editChooseProduct">确 定</el-button>
      </div>
     
     </el-dialog>
		
		


  </section>
</template>

<script>
import { getExchangeDailyDetail,getExchangeDailyDetailDay,getExchangeCompany,getExchangeApp,exchangeDailyEdit} from "../../api/api";
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      pdata: {
        company_id:"",
        issued_app_id:"",
//      date: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 2 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        status:""
      },
      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 2 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
    	loading:false,
      list: [],
      companys:[],
      apps:[],
      maxPage: 1,
      editDialog:false,
      chooseEditProduct:{
      	"visit_uv_out":'',
				"visit_uv_in":'',
      },
      toggleRowExpansionNum:'',
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
    };
  },
  watch: {
   dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
					//this.$router.push({ name:'成本日报详情',params:{issued_app_id:this.pdata.issued_app_id},query: {sdate:this.pdata.sdate,edate:this.pdata.edate} });
					this.getList();
        }
      },
      deep: true
    },
    'pdata.company_id':{
  		 handler(n, o) {
        this.getList();
      },
      deep: true
  	},
  	'pdata.issued_app_id':{
  		 handler(n, o) {
        this.getList();
      },
      deep: true
  	},
  },
  methods: {
  	goback(){
  		this.$router.back(-1)
  	},
    expands(r, es) {
    	this.loading=true;
      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `issued_app_id=${r.issued_app_id}&company_id=${r.company_id}&sdate=${this.dateVal[0]}&edate=${
          this.dateVal[1]
        }`;

        getExchangeDailyDetailDay(p, this.$cookie.getCookie("login")).then(res => {
        	this.loading=false;
          if (res.code == 200) {
          	if(res.data&&res.data.length>0){
          		 r.exData = res.data;
            	 this.$forceUpdate();
          	}           
          }
          else{
		      	this.loading=false;
		      }
        });
      }
      else{
      	this.loading=false;
      }
    },
    getList() {
    	this.loading=true;
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getExchangeDailyDetail(p, this.$cookie.getCookie("login")).then(res => {
      	this.loading=false;
        if (res.code == 200) {
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          if(res.data&&res.data.length>0){
          	 res.data.forEach((x,i) => {
	            	x.keyid='key'+i;
	              x.exData = [];
	            });
	            this.list=res.data;
          }
          else{
          		this.list=[];
          }
          
	        setTimeout(()=>{
	            	if(this.toggleRowExpansionNum!==''){
		            	document.getElementsByClassName('el-table__expand-icon')[this.toggleRowExpansionNum].click();
		            	//this.toggleRowExpansionNum='';
		            }
	        },500)
	        
        }
      });


    },
    getCompany(){
    	var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
    	getExchangeCompany(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          if(res.data&&res.data.length>0){
	            this.companys=res.data;
          }
          else{
          		this.companys=[];
          }
        }
      });
      getExchangeApp(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	
          if(res.data&&res.data.length>0){
	            this.apps=res.data;
          }
          else{
          		this.apps=[];
          }
        }
      });
    },
    editProduct(row,type,s){
    	if(s!==''){
    		this.toggleRowExpansionNum=s;
    	}
    	else{
    		this.toggleRowExpansionNum='';
    	}
    	this.editDialog=true;
    	if(row.index_id==undefined){
    		this.chooseEditProduct={
					"company_id":row.company_id,
					"issued_app_id":row.issued_app_id,
					"visit_uv_out":row.visit_uv_out,
					"visit_uv_in":row.visit_uv_in,
				}
    	}
    	else{
    		this.chooseEditProduct={
					"index_id":row.index_id,
					"visit_uv_out":row.visit_uv_out,
					"visit_uv_in":row.visit_uv_in,
				}
    	}
    	if(type=='list'){
    		this.chooseEditProduct.d_date = this.pdata.sdate
    	}
    	else if(type=='day'){
    			this.chooseEditProduct.d_date = row.d_date;
    	}
    },
    editChooseProduct(){

    	exchangeDailyEdit(this.chooseEditProduct, this.$cookie.getCookie("login")).then(res => {
    		 this.editDialog=false;
	        if (res.code == 200) {
		          this.$message({ message: "更新换量成功", type: "success" });
		          this.getList();
		      } else if (res.code == 400){
		          this.$message({ message: res.msg, type: "warning" });
		      } else{
		          this.$message.error(res.msg);
		      }
      });
    	
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },

  },
  computed: {
	    ...mapGetters([
	    	'groupid'
	    ])
  },
  mounted() {
    this.pdata.company_id = this.$route.params.company_id;
    if(this.$route.query.sdate){
    	  this.pdata.sdate=this.$route.query.sdate;
    }
    if(this.$route.query.edate){
    	 this.pdata.edate=this.$route.query.edate;
    }
  	this.dateVal = [this.pdata.sdate,this.pdata.edate];

    this.getList();
    this.getCompany();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
.el-input-number{
    max-width: 215px;width:100%;
}
.el-input-number .el-input__inner{
    text-align: left;
}
.selfTable .el-table__expanded-cell[class*=cell]{
	padding:0;
}
</style>


<style scoped="scoped">
	.red{
		color: #FF0000;
	}
</style>


// WEBPACK FOOTER //
// exchangeDailyDetail.vue?baba05a0